var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const baseAnchorData = { anchor: "" };
const AnchorData = {
  fromJSON(object) {
    const message = __spreadValues({}, baseAnchorData);
    message.anchor = object.anchor !== void 0 && object.anchor !== null ? String(object.anchor) : "";
    return message;
  },
  toJSON(message) {
    const obj = {};
    message.anchor !== void 0 && (obj.anchor = message.anchor);
    return obj;
  }
};
export {
  AnchorData
};
//# sourceMappingURL=decoration_anchor.js.map
